import { create } from "zustand";
import { StoredReplaceList, useReplaceList } from "./replace-list-store";
import { toast } from "react-toastify";

type QuickAddReplaceItemStore = {
  list: StoredReplaceList | null;
  nextList: StoredReplaceList | null;
  from: string;
  to: string;
};

export const useQuickAddReplaceItemStore = create<QuickAddReplaceItemStore>(
  () => ({
    list: null,
    nextList: null,
    from: "",
    to: "",
  })
);

export function nextReplaceList() {
  const { activeLists } = useReplaceList.getState();
  const { list, nextList } = useQuickAddReplaceItemStore.getState();
  if (!activeLists.length) {
    toast.info("You need to have at least one replace list active.");
  } else {
    let currentIndex = activeLists.findIndex(
      (list) => list._id === nextList?._id
    );
    if (currentIndex === -1) currentIndex = 0;
    if (list) {
      currentIndex =
        currentIndex >= activeLists.length - 2 ? 0 : currentIndex + 1;
    }
    const newNextList = activeLists[currentIndex];
    useQuickAddReplaceItemStore.setState({
      nextList: newNextList,
      list: newNextList,
    });
  }
}

export function lastReplaceList() {
  const { activeLists } = useReplaceList.getState();
  if (!activeLists.length) {
    toast.info("You need to have at least one replace list active.");
  } else {
    const list = activeLists.at(-1);
    useQuickAddReplaceItemStore.setState({ list });
  }
}
